import { FeaturePromotionStatus } from "../../types/FeaturePromotion";

const LABELS: Record<FeaturePromotionStatus, string> = {
  live: "Live",
  scheduled: "Scheduled",
  ended: "Ended",
  disabled: "Disabled",
};

const STYLES: Record<FeaturePromotionStatus, string> = {
  live: "bg-green-700 text-white",
  scheduled: "bg-blue-700 text-white",
  ended: "bg-stone-600 text-white",
  disabled: "bg-red-900 text-white",
};

export default function FeaturePromotionStatusBadge({ status }: { status: FeaturePromotionStatus }) {
  return (
    <span className={`inline-block px-2 py-0.5 rounded-xl text-sm ${STYLES[status]}`}>
      {LABELS[status]}
    </span>
  );
}
